import $ from 'jquery';
window.$ = window.jQuery = $;

import 'inputmask';
import 'jquery-datetimepicker';
import 'datatables.net-responsive-bs5';
import languageTR from 'datatables.net-plugins/i18n/tr.mjs';

jQuery(function () {
    Inputmask({ "mask": "99999999999" }).mask("national_id");
    Inputmask("email").mask("email");

    jQuery.datetimepicker.setLocale('tr');

    jQuery('#birthday').datetimepicker({
        timepicker: false,
        format: 'd-m-Y',
        lang: 'tr',
        mask: true,
        dayOfWeekStart: 1
    });

    // DataTables needs a header row and a uniform column count: skip tables without
    // a thead (e.g. hidden chart data) and ones showing a colspan "no records" row.
    // Tables paginated and filtered on the server opt out with data-no-datatable.
    $('table').filter(function () {
        return $(this).children('thead').length && !$(this).find('tbody td[colspan]').length && !$(this).is('[data-no-datatable]');
    }).dataTable({
        language: languageTR,
        pageLength: 25,
        responsive: true
     });

    function passwordChecker(input, alertbox) {

        $(input).on('keyup', function () {
            var number = /([0-9])/;
            var alphabets = /([a-zA-Z])/;
            var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
            if ($(input).val().length < 8) {
                $(alertbox).removeClass();
                $(alertbox).addClass('weak-password');
                $(alertbox).html("Basit (en az 8 karakter olmalıdır.)");
            } else {
                if ($(input).val().match(number) && $(input).val().match(alphabets) && $(input).val().match(special_characters)) {
                    $(alertbox).removeClass();
                    $(alertbox).addClass('strong-password');
                    $(alertbox).html("Güçlü");
                } else {
                    $(alertbox).removeClass();
                    $(alertbox).addClass('medium-password');
                    $(alertbox).html("Orta (harfleri, sayıları ve özel karakterleri veya bazı kombinasyonları içermelidir.)");
                }
            }

            if (($(input).attr('id') == "password-confirm") && ($("#password").val() != $("#password-confirm").val() ) ) {
                $(alertbox).removeClass();
                $(alertbox).addClass('notmatch-password');
                $(alertbox).html("Parolalar uyuşmuyor");
            }

            $(alertbox).addClass('password-strength-status');
        });

    }

    if($("#password").length>0) {
        passwordChecker($("#password"), $("#password-strength-status"));
    }
    if ($("#password").length > 0) {
        passwordChecker($("#password-confirm"), $("#password-confirm-strength-status"));
    }

    $("#phone_number_request").on("click", function () {

        var phone_number = $("#phone_number").val().replace(/\D/g, '');
        if (phone_number.length === 11 && phone_number.startsWith('0')) {
            phone_number = '90' + phone_number.substring(1);
        } else if (phone_number.length === 10 && phone_number.startsWith('5')) {
            phone_number = '90' + phone_number;
        }
        $("#hidden_phone_number").val(phone_number);

        if (phone_number.length < 10 || phone_number.length > 15) {
            alert('Lütfen geçerli bir telefon numarası girin.');
            return false;
        }

        $("#phone_number_validation_block").show();

        $.ajax({
            url: "/phone-number-verification-request",
            data: "phone_number=" + phone_number + "&_token=" + _globalToken._token,
            type: 'POST',
            success: function (data) {

                if (data.status == true) {

                    $("#phone_number").attr("readonly", "readonly");
                    $("#phone_number_request").hide();
                    $("#label_phone_number").show();
                    $("#phone_number").hide();
                    $("#phone_number_validation").focus();

                }
                else {
                    $("#register_button").prop("disabled", true);
                    alert(data.message);
                }
            },
            error: function (data) {
                if(data.responseJSON) {
                    alert(data.responseJSON.message);
                }
                else {
                    alert("API yanıt vermiyor.");
                }
                return false;
            }
        });


    });

    $("#validate_button").on("click", function () {

        var phone_number = $("#hidden_phone_number").val();
        var validation = $("#phone_number_validation").val();

        $.ajax({
            url: "/phone-number-verification",
            data: "phone_number=" + phone_number + "&validation=" + validation + "&_token=" + _globalToken._token,
            type: 'POST',
            success: function (data) {

                if (data.status == true) {

                    $("#phone_number_validation_block").hide();

                    $("#phone_number").attr("readonly", "readonly");
                    $("#label_phone_number").hide();
                    $("#phone_number").show();

                    $("#register_button").prop("disabled", false);
                    $("#info-block").hide();

                    $("#register_form").after('<input type="hidden" name="phone_number_verified" value="' + _globalToken._token + '">');
                }
                else {
                    $("#register_button").prop("disabled", true);
                    alert(data.message);
                }
            },
            error: function (data) {
                if (data.responseJSON) {
                    alert(data.responseJSON.message);
                }
                else {
                    alert("API yanıt vermiyor.");
                }
                return false;
            }
        });


    });

});
